import { Hashtag } from '@/javascripts/hashtag';
import { CategoryPresetHashtag } from '@/javascripts/category_preset_hashtag';
import { CategoryTemplate } from '@/javascripts/category_template';
import { PreviewImage } from '@/javascripts/preview_image';

export const initGuidanceModal = () => {
  document.addEventListener('DOMContentLoaded', async () => {
    const modalEl = document.getElementById('guidance_modal');
    if (!modalEl) return;

    const isPreview = modalEl.dataset.isPreview === 'true';

    // モーダル表示中はFAB（新規投稿ボタン）を非表示にする
    // プレビュー時は FAB 自体存在しない（layout が違う）が、念のため skip
    const fab = isPreview ? null : document.querySelector('.newPost_fab');
    if (fab) fab.style.display = 'none';

    // プレビュー時は閉じる操作（ESC・背景クリック）を無効化する。
    // バツボタンは見た目を維持するため非表示にせず、click 時に閉じる動作だけ抑止する。
    $(modalEl).modal({
      escapeClose: !isPreview,
      clickClose: !isPreview,
    });
    if (isPreview) {
      const closeBtn = modalEl.querySelector('.c-modal-close');
      if (closeBtn) {
        closeBtn.removeAttribute('rel'); // rel="modal:close" を外して jquery-modal の close を無効化
        closeBtn.addEventListener('click', (e) => e.preventDefault());
      }

      // 投稿フォームの送信・リンク遷移・submit ボタンを抑止する。
      // 入力欄やエディタの操作は通常通り行えるよう、submit / link クリックのみ無効化。
      modalEl.addEventListener('submit', (e) => e.preventDefault(), true);
      modalEl.addEventListener('click', (e) => {
        const trigger = e.target.closest(
          'a[href], button[type="submit"], input[type="submit"]',
        );
        if (trigger && !trigger.classList.contains('c-modal-close')) {
          e.preventDefault();
        }
      });
    }

    // モーダルを閉じたらFABを復元する
    $(modalEl).on($.modal.CLOSE, () => {
      if (fab) fab.style.display = '';
      recordPermanentDismissal(modalEl);
    });

    // CV ビーコンの二重送信ガード（1回の表示につき最大1送信）。
    // 遷移が始まるまでのダブルクリック窓を塞ぐのが役割で、リロード・再訪時は
    // モーダル自体が表示 dedup により再描画されないため、フラグの寿命はこのクロージャで足りる
    let conversionSent = false;

    modalEl.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;

      const link = e.target.closest('a[href]');
      if (link && !link.classList.contains('c-modal-close')) {
        recordPermanentDismissal(modalEl);
      }

      // visit_url のアクションボタン押下を CV として記録する。プレビューは計測対象外
      if (!isPreview && !conversionSent && e.target.closest('a[data-guidance-conversion="true"]')) {
        conversionSent = true; // 送信前に立てて連打の2回目以降を確実に弾く
        recordConversion(modalEl);
      }
    }, true);
    // NOTE: create_post の CV はここでは記録しない。投稿の保存成功時にサーバー側で記録する
    // （GuidanceConversionRecordable。押下時ビーコンは visit_url シナリオのみ）
    modalEl.addEventListener('submit', () => recordPermanentDismissal(modalEl), true);

    // ハッシュタグ
    if (modalEl.querySelector('.js-hashtag')) {
      new Hashtag();
      // 投稿フォーム同様、カテゴリ変更時の preset hashtag 反映を有効化する。
      // Tagify を attach した直後に走らせて、初期 preset を preset フラグ付きとして再投入する。
      // container を modalEl に限定し、メインページ側 form の `.js-category-id` を
      // 巻き込んで二重バインドしないようにする。
      new CategoryPresetHashtag(modalEl);
    }

    // アイキャッチ画像: ファイル選択ボタン・ファイル名表示・プレビュー
    const fileInput = modalEl.querySelector('#guidance_modal_lefile');
    if (fileInput) {
      new PreviewImage('#guidance_modal_lefile', '.js-caption-image-preview');

      const selectButton = modalEl.querySelector('.js-guidance-caption-select');
      if (selectButton) {
        selectButton.addEventListener('click', () => fileInput.click());
      }

      fileInput.addEventListener('change', () => {
        const photoCover = modalEl.querySelector('#guidance_modal_photoCover');
        const preview = modalEl.querySelector('.caption-image-preview');
        if (photoCover) {
          photoCover.value = fileInput.value.replace('C:\\fakepath\\', '');
        }
        if (preview) {
          preview.style.display = '';
        }
      });
    }

    // sns/announcement: SunEditor
    // スマホではエディタ高さを縮小して縦幅を抑え、ハッシュタグが見切れないようにする
    // suneditor の CSS は `.sun-editor` に user-select:none を付与するため、
    // 投稿詳細などモーダル外で `.sun-editor` を表示する画面で本文選択ができなくなる。
    // ここで動的 import して、モーダルにエディタ用 textarea がある場合のみロードする。
    const editorTextarea = modalEl.querySelector('textarea[data-editor-id]');
    if (editorTextarea) {
      const { initEditor } = await import('@/javascripts/suneditor/init');
      const editorId = editorTextarea.dataset.editorId ?? 'editor';
      const isMobile = window.innerWidth < 768;
      if (isMobile) {
        initEditor(editorId, false, null, false, '', '200px');
      } else {
        initEditor(editorId);
      }
    }

    // プレビューは対象外: カテゴリ切替は iframe reload（サーバー側プリフィル）で反映されるうえ、
    // AdminUser 閲覧時は current_user が nil でテンプレート取得 API が公開カテゴリしか引けないため。
    // CategoryPresetHashtag と同様に container を modalEl に限定し、
    // ページ本体側の `.js-category-id` を巻き込まないようにする。
    if (!isPreview && modalEl.querySelector('.js-category-id')) {
      new CategoryTemplate(modalEl);
    }
  });
};

const getCsrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

// visit_url シナリオの CV 記録ビーコン。遷移開始後も送信が完了するよう keepalive を付ける
// （fire-and-forget: 応答は使わず、失敗してもユーザー体験には影響させない）
const recordConversion = (modalEl) => {
  const url = modalEl.dataset.conversionUrl;
  const guidanceUrlName = modalEl.dataset.guidanceUrlName;
  if (!url || !guidanceUrlName) return;

  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({ guidance_url_name: guidanceUrlName }),
  }).catch(() => undefined);
};

const recordPermanentDismissal = (modalEl) => {
  if (modalEl.dataset.allowUserDismissal !== 'true') return;

  const checkbox = modalEl.querySelector('[data-guidance-dismiss-checkbox="true"]');
  if (!checkbox?.checked) return;

  const url = modalEl.dataset.dismissUrl;
  const guidanceUrlName = modalEl.dataset.guidanceUrlName;
  if (!url || !guidanceUrlName) return;

  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({ guidance_url_name: guidanceUrlName }),
  }).catch(() => undefined);
};
